// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CloseIconSignature {
  Element: SVGSVGElement;
}

export const CloseIcon: TOC<CloseIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M21 4.4615L19.5375 3L12.0005 10.538L4.46253 3L3 4.4615L10.538 11.9995L3 19.5375L4.46253 20.999L12.0005 13.461L19.5375 20.999L21 19.5375L13.462 11.9995L21 4.4615Z"/>
</svg>
</template>;